export default __webpack_public_path__ + "static/media/new404.12da717c.svg";